import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { useTemplateNodeSoftLimit } from 'src/features/templateEdit/useTemplateNodeSoftLimit'

/**
 * ひな形全体のノード数が上限を超えた瞬間に、削除を促すダイアログを出す。
 * 超過中は保存ボタンも非活性になる(EditTemplate)ため、閉じた後も保存はできない。
 */
export const TemplateNodeSoftLimitDialog = () => {
  const { isOverLimit } = useTemplateNodeSoftLimit()
  const [isOpen, setIsOpen] = useState(false)
  const wasOverLimit = useRef(false)

  useEffect(() => {
    // 超過に入った瞬間だけ開く。容量内に戻れば、次に超過したときまた開く。
    if (isOverLimit && !wasOverLimit.current) {
      setIsOpen(true)
    }
    wasOverLimit.current = isOverLimit
  }, [isOverLimit])

  const onClose = () => setIsOpen(false)

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="template-node-soft-limit-title"
      aria-describedby="template-node-soft-limit-description"
    >
      <DialogTitle id="template-node-soft-limit-title">
        追加できる質問、セクション、条件分岐の容量を超えています。いずれかを削除してください。
      </DialogTitle>
      <DialogContent />
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={onClose}>
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  )
}
